const state = {};
const getters = {};
const actions = {
    //Items
    async getItems({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/performance-assesment-settings`, {params:params})
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
    async createContractSum({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.post(`api/performance-assesment-settings/contract-sum`, params)
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
    async updateContractSum({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.put(`api/performance-assesment-settings/contract-sum/${params.id}`, params)
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
    async createMaintenanceWeight({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.post(`api/performance-assesment-settings/maintenance-weight`, params)
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
    async updateMaintenanceWeight({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.put(`api/performance-assesment-settings/maintenance-weight/${params.id}`, params)
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
    async savePASettings({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.post(`api/performance-assesment-settings`, params)
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
    async deleteItems({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.delete(`api/performance-assesment-settings`, {
                data: {
                    ids:  params.ids,
                    type: params.type
                }
            })
            .then(response => {
                resolve( response );
            })
            .catch(error => reject( error ));
        });
    },
    async savePASettingsRatesOfDeduction({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.post(`/api/performance-assesment-settings/rates-of-deduction`, params)
            .then(response => {
                resolve( response.data.data );
            })
            .catch(error => reject( error ));
        });
    },
    async updatePASettingsRatesOfDeduction({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.put(`/api/performance-assesment-settings/rates-of-deduction/${params.id}`, params)
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
};

const mutations = {};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
